import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StorageStatusIndicator({ isAuthenticated, isSaving, hasError = false }) {
  const { t } = useTranslation();

  if (!isAuthenticated) {
    return (
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-red-500">
        <span className="h-2 w-2 rounded-full bg-current" aria-hidden />
        {t('jupa.workspace.storageNotActivated')}
      </span>
    );
  }

  if (isSaving) {
    return (
      <span
        className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-yellow-500"
        role="status"
        aria-live="polite"
      >
        <span
          className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-r-transparent"
          aria-hidden
        />
        {t('jupa.workspace.storageSaving')}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium ${
        hasError ? 'text-red-500' : 'text-green-500'
      }`}
      role="status"
      aria-live="polite"
    >
      <span className="h-2 w-2 rounded-full bg-current" aria-hidden />
      {t(hasError ? 'jupa.workspace.storageFailed' : 'jupa.workspace.storageSaved')}
    </span>
  );
}
